module.exports = __webpack_public_path__ + "img/FAR2_600x361.7630e199.jpg";